export class StateNode {
    constructor(data) {
        this.data = data;
        this.transitions = [];
    }
    addTransition(nextState, condition) {
        this.transitions.push({ nextState, condition });
    }
    evaluate(data) {
        for (const transition of this.transitions) {
            if (transition.condition.evaluate(data))
                return transition.nextState;
        }
        return undefined;
    }
    getNextStates() {
        return this.transitions.map(t => t.nextState);
    }
    getTransitions() {
        return [...this.transitions];
    }
}
export class StateMachine {
    constructor() {
        this.allStates = [];
    }
    getAllStates() {
        return this.allStates;
    }
    setAllStates(states) {
        this.allStates = states;
    }
    setStartNode(startNode) {
        this.startNode = startNode;
        this.currentNode = this.startNode;
    }
    setCurrentState(nextNode) {
        this.currentNode = nextNode;
    }
    getCurrentState() {
        var _a;
        return (_a = this.currentNode) === null || _a === void 0 ? void 0 : _a.data;
    }
    getStateByNameOrId(stateName, stateId) {
        if (stateId === undefined && stateName === undefined)
            return undefined;
        return this.allStates.find(stateNode => stateId !== undefined ? stateNode.data.id === stateId : stateNode.data.name === stateName);
    }
    update(context) {
        var _a, _b, _c, _d;
        let nextNode;
        if (context === undefined) {
            // just for debugging purpose
            const nextStages = (_a = this.currentNode) === null || _a === void 0 ? void 0 : _a.getNextStates();
            if (nextStages !== undefined && nextStages.length > 0) {
                nextNode = nextStages[0];
            }
        }
        else {
            nextNode = (_b = this.currentNode) === null || _b === void 0 ? void 0 : _b.evaluate(context);
        }
        // if next node is undefined, there is no state change, so we stay in the current state. this should not happen
        // unless this state is a final state
        if (nextNode === undefined)
            return {
                previousState: (_c = this.currentNode) === null || _c === void 0 ? void 0 : _c.data,
                nextState: undefined
            };
        const previousState = (_d = this.currentNode) === null || _d === void 0 ? void 0 : _d.data;
        const nextState = nextNode.data;
        this.currentNode = nextNode;
        return {
            previousState,
            nextState
        };
    }
}
